import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import * as styles from './Terms.scss';
import { connect } from 'react-redux';
import { loadWebagreement } from 'redux/modules/config';

var marked = require('marked');

var Terms = (_dec = connect(function (state) {
  return {
    webagreement: state.config.webagreement ? state.config.webagreement.SMB : null
  };
}, {
  loadWebagreement: loadWebagreement
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Terms, _Component);

  var _super = _createSuper(Terms);

  function Terms() {
    _classCallCheck(this, Terms);

    return _super.apply(this, arguments);
  }

  _createClass(Terms, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.loadWebagreement('SMB');
    }
  }, {
    key: "render",
    value: function render() {
      var terms = this.props.webagreement ? this.props.webagreement.content : '';
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("h1", {
        className: styles.header
      }, "Terms And Conditions"), /*#__PURE__*/React.createElement("span", {
        className: "termsWrap",
        dangerouslySetInnerHTML: {
          __html: marked(terms)
        }
      }));
    }
  }]);

  return Terms;
}(Component)) || _class);
export { Terms as default };